import React, { useEffect, useState } from "react";
import { useUserStore } from "../../store/userStore.js";
import { useLocation } from "react-router-dom";
import { Button, DatePicker, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import moment from "moment";


import UserProfilePhotoBox from "../userprofilephptos/userprofilephotobox";
import UserDescriptionBox from "./userdescriptionbox";
import ChangeRequestBox from "./changerequestbox";
import TrustBadgeBox from "./trustbadgebox";

import images from "../../assets";

export default function UserRequests() {
  const location = useLocation();
  const {
    user: userData,
    getUser,
    updateUser: updateUserAction,
    deleteChangeRequest,
  } = useUserStore();

  const username = location.pathname.split("/")[2];

  const [galleryData, setGalleryData] = useState();
  const [trustBadgeData, setTrustBadgeData] = useState();

  useEffect(() => {
    setGalleryData(userData?.imageGallery);
    setTrustBadgeData(userData?.trustbadge);
  }, [userData]);

  useEffect(() => {
    getprofileData();
  }, [username]);

  const getprofileData = () => {
    const payload = { username };
    getUser(payload);
  };

  const updatePhotos = (newGalleryData, status, reason) => {
    const updatedGalleryData = newGalleryData?.map(
      ({ signedUrl, ...rest }) => rest
    );

    const payload = {
      username,
      data: { imageGallery: updatedGalleryData },
      notification: {
        route: "/gallery",
        reason: reason ?? null,
        event:
          status === "approved" ? "photoApprovedAdmin" : "photoRejectedAdmin",
      },
    };
    submitUserUpdate(payload);
  };

  const updateTrustBadge = (newTbData, status, reason) => {
    const updatedTbData = newTbData?.map(({ signedUrl, ...rest }) => rest);

    const payload = {
      username,
      data: {
        trustbadge: updatedTbData,
        trustbadgeStatus: status,
      },
      notification: {
        route: "/trust-badge",
        reason: reason ?? null,
        event:
          status === "approved"
            ? "trustBadgeApprovedAdmin"
            : "trustBadgeRejectedAdmin",
      },
    };
    submitUserUpdate(payload);
  };

  const updateProfileDesc = (newDesc, status, reason) => {
    const payload = {
      username,
      data: {
        profileDescription: newDesc,
        profileDescriptionStatus: status,
      },
      notification: {
        route: "/edit-profile?tab=profileDesc",
        reason: reason ?? null,
        event:
          status === "approved"
            ? "profileDescApprovedAdmin"
            : "profileDescRejectedAdmin",
      },
    };
    submitUserUpdate(payload);
  };

  const updateIdealMatchDesc = (newDesc, status, reason) => {
    const payload = {
      username,
      data: {
        matchPreference: {
          ...userData?.matchPreference,
          idealMatchDescription: newDesc,
          idealMatchDescriptionStatus: status,
        },
      },
      notification: {
        route: "/match-preference?tab=idealMatch",
        reason: reason ?? null,
        event:
          status === "approved"
            ? "idealMatchApprovedAdmin"
            : "idealMatchRejectedAdmin",
      },
    };
    submitUserUpdate(payload);
  };
  const updateCountry = (status, reason) => {
    const payload = {
      username,
      data:
        status === "approved"
          ? {
              country: userData?.countryChangeRequest?.country,
              stateProvince: userData?.countryChangeRequest?.stateProvince,
            }
          : {
              country: userData?.country,
              stateProvince: userData?.stateProvince,
            },
      notification: {
        route: "/edit-profile",
        reason: reason ?? null,
        event:
          status === "approved"
            ? "countryChangeApprovedAdmin"
            : "countryChangeRejectedAdmin",
      },
    };
    submitUserUpdate(payload);
    deleteChangeReq(userData?.countryChangeRequest?.id);
  };
  const updateDOB = (status, reason) => {
    const payload = {
      username,
      data: {
        dateOfBirth:
          status === "approved"
            ? userData?.dobChangeRequest?.dateOfBirth
            : userData?.dateOfBirth,
      },
      notification: {
        route: "/edit-profile",
        reason: reason ?? null,
        event:
          status === "approved"
            ? "dobChangeApprovedAdmin"
            : "dobChangeRejectedAdmin",
      },
    };
    submitUserUpdate(payload);
    deleteChangeReq(userData?.dobChangeRequest?.id);
  };

  const submitUserUpdate = (payload) => {
    updateUserAction(payload, () => getprofileData());
  };
  const deleteChangeReq = (id) => {
    const payload = {
      id,
      username: userData?.username,
    };
    deleteChangeRequest(payload);
  };

  return (
    <>
      <div className="w-full justify-start gap-4 flex flex-col">
        {/* gallery itemns */}
        {userData?.imageGallery && userData?.imageGallery?.length > 0 && (
          <div className="grid grid-cols-4 gap-5">
            {userData?.imageGallery?.map(
              (item, index) =>
                item?.status === "pending" && (
                  <UserProfilePhotoBox
                    galleryData={galleryData}
                    updateProfile={updatePhotos}
                    key={index}
                    userimg={item?.signedUrl}
                    userimgoriginal={item?.originalUrl}
                    status={item?.status}
                  />
                )
            )}
          </div>
        )}
        {/* trust badge */}
        {userData?.trustbadge && userData?.trustbadge?.length > 0 && (
          <div className="grid grid-cols-4 gap-5">
            {userData?.trustbadge?.map(
              (item, index) =>
                item?.status === "pending" && (
                  <TrustBadgeBox
                    key={index}
                    item={item}
                    updateTrustBadge={updateTrustBadge}
                    trustBadgeData={trustBadgeData}
                  />
                )
            )}
          </div>
        )}

        {/* other */}
        <div className="grid grid-cols-2 gap-4 mt-8">
          {userData?.profileDescription &&
            userData?.profileDescriptionStatus === "pending" && (
              <UserDescriptionBox
                title="Profile Description"
                desc={userData?.profileDescription}
                editicon={images.editWhiteIcon}
                editbtntext="Edit Description"
                editDesc={updateProfileDesc}
                approvetext="Approve profile description?"
                approvedesc="Are you sure you want to approve?"
                rejecttext="Reject profile description?"
                rejectdesc="Are you sure you want to reject?"
              />
            )}
          {userData?.matchPreference?.idealMatchDescription &&
            userData?.matchPreference?.idealMatchDescriptionStatus ===
              "pending" && (
              <UserDescriptionBox
                title="Ideal Match Description"
                desc={userData?.matchPreference?.idealMatchDescription}
                editicon={images.editWhiteIcon}
                statusname="Pending"
                editDesc={updateIdealMatchDesc}
                approvetext="Approve ideal match description?"
                approvedesc="Are you sure you want to approve?"
                rejecttext="Reject ideal match description?"
                rejectdesc="Are you sure you want to reject?"
              />
            )}
        </div>
        <div className="w-full flex flex-row gap-4 mt-8 flex-wrap">
          {userData?.countryChangeRequest && (
            <ChangeRequestBox
              heading="Country Change Request"
              userdatatitle="User Country"
              requesteddatatitle="Requested Country"
              handleUpdate={updateCountry}
              approvetext="Approve country change request?"
              approvedesc="Are you sure you want to approve?"
              rejecttext="Reject country change request?"
              rejectdesc="Are you sure you want to reject?"
              userinputdata={
                <div className="flex flex-col w-full gap-2">
                  <div className="border bg-gray-200 border-gray-300 px-2 py-3.5 rounded-md w-full">
                    {userData?.country}
                  </div>
                  <div className="border bg-gray-200 border-gray-300 px-2 py-3.5 rounded-md w-full">
                    {userData?.stateProvince}
                  </div>
                </div>
              }
              userrequestdata={
                <div className="flex flex-col w-full gap-2">
                  <div className="border bg-gray-200 border-gray-300 px-2 py-3.5 rounded-md w-full">
                    {userData?.countryChangeRequest?.country}
                  </div>
                  <div className="border bg-gray-200 border-gray-300 px-2 py-3.5 rounded-md w-full">
                    {userData?.countryChangeRequest?.stateProvince}
                  </div>
                </div>
              }
            >
              {userData?.countryChangeRequest?.reason && (
                <div>
                  <strong>Reason:</strong>{" "}
                  {userData?.countryChangeRequest?.reason}
                </div>
              )}
            </ChangeRequestBox>
          )}
          {/* {userData?.genderChangeRequest && (
            <ChangeRequestBox
              heading="Gender Change Request"
              userdatatitle="User Gender"
              requesteddatatitle="Requested Gender"
              handleUpdate={null}
              approvetext="Approve gender change request?"
              approvedesc="Are you sure you want to approve?"
              rejecttext="Reject gender change request?"
              rejectdesc="Are you sure you want to reject?"
              userinputdata={
                <div className="border bg-gray-200 border-gray-300 px-2 py-3.5 rounded-md w-full">
                  {userData?.gender}
                </div>
              }
              userrequestdata={
                <div className="border bg-gray-200 border-gray-300 px-2 py-3.5 rounded-md w-full">
                  {userData?.genderChangeRequest?.gender}
                </div>
              }
            >
              {userData?.genderChangeRequest?.reason && (
                <div className="self-stretch">
                  <span className="text-[#222222] text-sm font-semibold font-['Poppins'] leading-tight">
                    Reason:{" "}
                  </span>
                  <span className="text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
                    {userData?.genderChangeRequest?.reason}
                  </span>
                </div>
              )}
            </ChangeRequestBox>
          )} */}
          {userData?.dobChangeRequest && (
            <ChangeRequestBox
              heading="Date of Birth Change Request"
              userdatatitle="User Date of Birth"
              requesteddatatitle="Requested Date of Birth"
              handleUpdate={updateDOB}
              approvetext="Approve date of birth change request?"
              approvedesc="Are you sure you want to approve?"
              rejecttext="Reject date of birth change request?"
              rejectdesc="Are you sure you want to reject?"
              userinputdata={
                <div className="border bg-gray-200 border-gray-300 px-2 py-3.5 rounded-md w-full">
                  {userData?.dateOfBirth
                    ? moment(userData?.dateOfBirth).format("YYYY-MM-DD")
                    : null}
                </div>
              }
              userrequestdata={
                <div className="border bg-gray-200 border-gray-300 px-2 py-3.5 rounded-md w-full">
                  {userData?.dobChangeRequest
                    ? moment(userData?.dobChangeRequest?.dateOfBirth).format(
                        "YYYY-MM-DD"
                      )
                    : null}
                </div>
              }
            />
          )}
        </div>
      </div>
    </>
  );
}








